import React, { createContext } from "react";
import createReactClass from "create-react-class";
import extend from "lodash/extend";

const ActionRootContext = createContext({ editable: {}, dispatcher: {} });
const ActionRoot = (View, pageStores, editable, dispatcher) => {

    let WrappedActionRoot = createReactClass({
        render() {
            const contextValue = extend({}, {
                editable,
                dispatcher
            }, pageStores || {});

            return (
                <ActionRootContext.Provider value={contextValue}>
                    <View />
                </ActionRootContext.Provider>
            );
        }

    });

    return WrappedActionRoot;
};

export { ActionRootContext };
export default ActionRoot;
